import type { EventURLAction } from '../calendar.types';
import type { PassengerType, WeightAndBalanceType } from './weight-and-balance.types';

export const DEFAULT_WEIGHT = '0.00';

export const WEIGHT_UNITS = {
  lbs: 'lbs',
  kg: 'kg',
  percent: '%',
  gal: 'gal',
  liters: 'liters'
};

export const CALCULATE_WEIGHT_AND_BALANCE_ACTION = 'CALCULATE_PASSENGERS_ACTION';
// Month-view save signal: dispatched instead of legacy getEvent() when timezone is a string
export const WB_SAVE_DONE = 'WB_SAVE_DONE';
// Seeds aircraft context from EventViewModal so month-view W&B can resolve aircraft/pilotRight
export const SET_WB_EVENT_CONTEXT = 'SET_WB_EVENT_CONTEXT';

export const LOAD_MANIFEST: EventURLAction = 'load-weight-and-balance-manifest';
export const WEIGHT_AND_BALANCE: EventURLAction = 'weight-and-balance';
export const ADD_PASSENGER: EventURLAction = 'add-passenger';
export const EDIT_PASSENGER: EventURLAction = 'edit-passenger';

export const DEFAULT_WEIGHT_AND_BALANCE: WeightAndBalanceType = {
  fuelWeight: 0,
  passengers: [],
  rows: [],
  taxiRunUpFuelBurn: 0,
  unit: WEIGHT_UNITS.lbs,
  weightAndBalanceTable: {},
  image: undefined
};

export const DEFAULT_PASSENGER: PassengerType = {
  fullName: '',
  weight: '',
  unit: WEIGHT_UNITS.lbs,
  phoneNumber: '',
  email: ''
};

export const STRONG_PARAMETERS = ['Takeoff Weight & CG', 'Landing Weight & CG'];

export const ROW_GROUP = 'row';
export const PASSENGER_GROUP = 'passenger';
